import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import secureLocalStorage from 'react-secure-storage';
import ServerDown from '../images/undraw/undraw_server_down_s-4-lk.svg';

import Swal from 'sweetalert2';

const useAuthentication = () => {
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const loginUser = async (loginData, location, navigate) => {
    try {
      setIsLoading(true);

      // Store login data in secureLocalStorage
      secureLocalStorage.setItem('state', loginData);

      // Prepare the request body
      const body = JSON.stringify({
        email: loginData.email,
        password: loginData.password,
      });

      // Choose the URL based on the location
      const url =
        location.pathname === '/admin'
          ? `https://api-b2b.fasttracktourism.com/auth/admin/signin`
          : `https://api-b2b.fasttracktourism.com/auth/signin`;

      // Make the fetch request
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          Accept: '*/*',
          'Content-Type': 'application/json',
        },
        body: body,
      });

      if (!response.ok) {
        throw new Error(`${response.status}`);
      }

      const resData = await response.json();
      const data = {
        ...resData,
        role: resData.role || 'agent',
      };
      // Handle success
      secureLocalStorage.setItem(
        location.pathname === '/admin' ? 'admin-info' : 'user-info',
        data
      );
      const destination =
        location.pathname === '/admin' ? '/dashboard' : '/user/dashboard';
      navigate(destination);
    } catch (error) {
      setIsLoading(false); // Set loading to false in case of error

      if (error.message.includes('401')) {
        setError(
          location.pathname === '/admin'
            ? 'Admin Wrong password'
            : 'Agent Wrong password'
        );
      } else {
        setError(
          location.pathname === '/admin' ? 'Admin not found' : 'Agent not found'
        );
      }
    }
  };

  const logout = () => {
    secureLocalStorage.removeItem('user-info');
    secureLocalStorage.removeItem('commissionData');
    secureLocalStorage.removeItem('state');
    navigate('/');
  };

  const adminLogout = () => {
    secureLocalStorage.removeItem('admin-info');
    navigate('/admin');
  };

  return {
    loginUser,
    logout,
    adminLogout,
    isLoading,
    error,
  };
};

export default useAuthentication;
